import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "../../../styles/MBABatch.css";
import { getFINXLDetailsList, saveFINXLDetailsList } from "../../../services/getAllApi";


const FinxlCertificationsTable = ({students, onFinxlCertDataChange}) => {
  // const [students, setStudents] = useState([]); // Store student details
  const [formData, setFormData] = useState({}); // Store fee details

  // Fetch student data from backend
   const fetchFINXLDetails = async () => {
      try {
        const finxlresponse = await getFINXLDetailsList();    
        const initialData = {};
        students.forEach((student) => {
        const finxlCertifications = finxlresponse.find((finxlcertification) => String(finxlcertification.student_id) === String(student.student_id) ) || {};
        initialData[student.student_id] = { 
          name: finxlCertifications.name || student.name ||"",
          fmer: finxlCertifications.fmer || "", 
          fmer_date: finxlCertifications.fmer_date || "",
          fmer_status: finxlCertifications.fmer_status || "Pending",

          fpa: finxlCertifications.fpa || "",
          fpa_date: finxlCertifications.fpa_date || "",
          fpa_status: finxlCertifications.fpa_status || "Pending",

          ib: finxlCertifications.ib || "",
          ib_date: finxlCertifications.ib_date || "",
          ib_status: finxlCertifications.ib_status || "Pending",

          startupVal: finxlCertifications.startupVal || "",
          startupVal_date: finxlCertifications.startupVal_date || "",
          startupVal_status: finxlCertifications.startupVal_status || "Pending",

          powerBi: finxlCertifications.powerBi || "",
          powerBi_date: finxlCertifications.powerBi_date || "",
          powerBi_status: finxlCertifications.powerBi_status || "Pending",

          anaplan1: finxlCertifications.anaplan1 || "",
          anaplan1_date: finxlCertifications.anaplan1_date || "",
          anaplan1_status: finxlCertifications.anaplan1_status || "Pending",

          anaplan2: finxlCertifications.anaplan2 || "",
          anaplan2_date: finxlCertifications.anaplan2_date || "",
          anaplan2_status: finxlCertifications.anaplan2_status || "Pending",
        };
      });

      setFormData(initialData);
      onFinxlCertDataChange(initialData);

    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  };

  // Call fetchStudents inside useEffect
  useEffect(() => {
    fetchFINXLDetails();
  }, []);

  useEffect(() => {
    onFinxlCertDataChange(formData); // ✅ Sync with parent on every update
  }, [formData]);

  // Handle input changes
  const handleChange = (e, student_id) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [student_id]: {
        ...formData[student_id],
        [name]: type === "checkbox" ? checked : value,
      },
    });
  };

  const handleSubmit = async () => {
      // const FinxlCertDataArray = Object.keys(formData).map((student_id) => {
        // const student = students.find((s) => s.student_id === student_id);
      const FinxlCertDataArray = students.map((student) => {
      // const student = students.find((s) => s.student_id === student_id);
      return {
        student_id: student.student_id.toString(), // ✅ match DB type
        name: formData[student.student_id]?.name || student.name || "",
        fmer: formData[student.student_id]?.fmer || "",
        fmer_date: formData[student.student_id]?.fmer_date || "",
        fmer_status: formData[student.student_id]?.fmer_status || "Pending",
        fpa: formData[student.student_id]?.fpa || "",
        fpa_date: formData[student.student_id]?.fpa_date || "",
        fpa_status: formData[student.student_id]?.fpa_status || "Pending",
        ib: formData[student.student_id]?.ib || "",
        ib_date: formData[student.student_id]?.ib_date || "",
        ib_status: formData[student.student_id]?.ib_status || "Pending",
        startupVal: formData[student.student_id]?.startupVal || "",
        startupVal_date: formData[student.student_id]?.startupVal_date || "",
        startupVal_status: formData[student.student_id]?.startupVal_status || "Pending",
        powerBi: formData[student.student_id]?.powerBi || "",
        powerBi_date: formData[student.student_id]?.powerBi_date || "",
        powerBi_status: formData[student.student_id]?.powerBi_status || "Pending",
        anaplan1: formData[student.student_id]?.anaplan1 || "",
        anaplan1_date: formData[student.student_id]?.anaplan1_date || "",
        anaplan1_status: formData[student.student_id]?.anaplan1_status || "Pending",
        anaplan2: formData[student.student_id]?.anaplan2 || "",
        anaplan2_date: formData[student.student_id]?.anaplan2_date || "",
        anaplan2_status: formData[student.student_id]?.anaplan2_status || "Pending",
          // ...formData[student_id],
        };
      });
  
  
      console.log("Submitting Data:", FinxlCertDataArray);
  
      try {
        await saveFINXLDetailsList(FinxlCertDataArray);
        Swal.fire("Success", "FINXL Certifications Data saved successfully!", "success");
        await fetchFINXLDetails();
      } catch (error) {
        Swal.fire("Error", "Failed to save data", "error");
      }
  };

  return (
    <div>
      <button onClick={handleSubmit} className="handle-btn">
        <p className="button-save">Save Data</p>
      </button>
      <div className="table-container-MBA-Students-list">

        <table>
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Student ID</th>
              <th>Name</th>
              <th>FMER (3.5m)</th>
              <th>FPA (2.5m)</th>
              <th>IB (1m)</th>
              <th>Startup Valuation (3m)</th>
              <th>Microsoft Power BI (2m)</th>
              <th>Anaplan Level I (2m)</th>
              <th>Anaplan Level II (2m)</th>
            </tr>
          </thead>
          <tbody>
            {students.map((student, index) => (
              <tr key={student.id}>
                <td>{index + 1}</td>
                <td>{student.student_id}</td>
                <td>{student.name}</td>
                {[
                  { field: "fmer", dateField: "fmer_date", checkField: "fmer_status" },
                  { field: "fpa", dateField: "fpa_date", checkField: "fpa_status" },
                  { field: "ib", dateField: "ib_date", checkField: "ib_status" },
                  { field: "startupVal", dateField: "startupVal_date", checkField: "startupVal_status" },
                  { field: "powerBi", dateField: "powerBi_date", checkField: "powerBi_status" },
                  { field: "anaplan1", dateField: "anaplan1_date", checkField: "anaplan1_status" },
                  { field: "anaplan2", dateField: "anaplan2_date", checkField: "anaplan2_status" }
                ].map((finxlcertification, idx) => (
                  <td key={idx}>
                  <div style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "5px",
                      padding: "5px"
                    }}>
                    <input
                      type="number"
                      name={finxlcertification.field}
                      value={formData[student.student_id]?.[finxlcertification.field] || ""}
                      onChange={(e) => handleChange(e, student.student_id)}
                      style={{ width: "120px", textAlign: "center" }}
                    />
                    <input
                      type="date"
                      name={finxlcertification.dateField}
                      value={formData[student.student_id]?.[finxlcertification.dateField] || ""}
                      onChange={(e) => handleChange(e, student.student_id)}
                      style={{ width: "120px", textAlign: "center" }}
                    />
                    
                      <select
                      name={finxlcertification.checkField}
                      value={formData[student.student_id]?.[finxlcertification.checkField] || "Pending"}
                      onChange={(e) => handleChange(e, student.student_id)}
                      style={{
                        width: "120px",
                        textAlign: "center",
                        cursor: "pointer",
                        padding: "5px",
                        fontWeight: "bold",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        backgroundColor:
                          formData[student.student_id]?.[finxlcertification.checkField] === "Completed"
                            ? "green"
                            : formData[student.student_id]?.[finxlcertification.checkField] === "Ongoing"
                            ? "orange"
                            : "red",
                        color: "white",
                      }}
                    >
                      <option value="Pending" style={{ backgroundColor: "red", color: "white" }}>Pending</option>
                      <option value="Ongoing" style={{ backgroundColor: "orange", color: "white" }}>Ongoing</option>
                      <option value="Completed" style={{ backgroundColor: "green", color: "white" }}>Completed</option>
                    </select>
                  </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FinxlCertificationsTable;
